import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=041371f9&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=ts"
export * from "./Inbox.vue?vue&type=script&lang=ts"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=041371f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041371f9",
  null
  
)

export default component.exports